// Scheda prodotto: pulsante «Acquista ora» (snippet buy-buttons, impostazione pa_buy_now).
// Aggiunge al carrello la variante e la quantità scelte, poi porta direttamente al check-out Shopify.
// Resta disattivato insieme ad «Aggiungi al carrello» (esaurito / non disponibile).
(() => {
  const syncDisabled = (btn) => {
    const submit = document.getElementById(btn.dataset.form)?.querySelector('[name="add"]');
    if (!submit) return;
    const apply = () => (btn.disabled = submit.disabled);
    apply();
    new MutationObserver(apply).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
  };

  const showError = (btn, message) => {
    const wrapper = btn.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const text = wrapper?.querySelector('.product-form__error-message');
    if (!wrapper || !text) return;
    text.textContent = message;
    wrapper.hidden = false;
  };

  const setLoading = (btn, loading) => {
    btn.classList.toggle('loading', loading);
    btn.setAttribute('aria-busy', String(loading));
    btn.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
  };

  const init = () => document.querySelectorAll('[data-pa-buy-now]').forEach(syncDisabled);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-pa-buy-now]');
    if (!btn || btn.disabled || btn.classList.contains('loading')) return;
    const form = document.getElementById(btn.dataset.form);
    if (!form) return;

    setLoading(btn, true);
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.status) {
        showError(btn, data.description || data.message || 'Impossibile aggiungere il prodotto. Riprova.');
        setLoading(btn, false);
        return;
      }
      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    } catch {
      showError(btn, 'Connessione non riuscita. Riprova.');
      setLoading(btn, false);
    }
  });

  // Tornando indietro dal check-out (cache del browser) il pulsante non deve restare in caricamento.
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-pa-buy-now].loading').forEach((b) => setLoading(b, false)));
})();
